import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './eatSessionQuery.gql';
import { EatSessionFragmentDoc } from '../../fragments/eat/EatSessionFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type EatSessionQuery_currentSession_Session_user_User = {
  __typename: 'User',
  id: number,
  avatarUrl?: string | null,
  displayName: string,
  email?: string | null,
  firstName?: string | null
};

export type EatSessionQuery_currentSession_Session = {
  __typename: 'Session',
  id: string,
  user?: EatSessionQuery_currentSession_Session_user_User | null
};

export type EatSessionQuery_Query = {
  __typename?: 'Query',
  currentSession: EatSessionQuery_currentSession_Session
};


export type EatSessionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EatSessionQuery = EatSessionQuery_Query;


export const EatSessionDocument = /*#__PURE__*/ document as unknown as DocumentNode<EatSessionQuery, EatSessionQueryVariables>;


/**
 * __useEatSessionQuery__
 *
 * To run a query within a React component, call `useEatSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEatSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEatSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useEatSessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EatSessionQuery, EatSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EatSessionQuery, EatSessionQueryVariables>(EatSessionDocument, options);
      }
export function useEatSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EatSessionQuery, EatSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EatSessionQuery, EatSessionQueryVariables>(EatSessionDocument, options);
        }
// @ts-ignore
export function useEatSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EatSessionQuery, EatSessionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EatSessionQuery, EatSessionQueryVariables>;
export function useEatSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EatSessionQuery, EatSessionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EatSessionQuery | undefined, EatSessionQueryVariables>;
export function useEatSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EatSessionQuery, EatSessionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EatSessionQuery, EatSessionQueryVariables>(EatSessionDocument, options);
        }
export type EatSessionQueryHookResult = ReturnType<typeof useEatSessionQuery>;
export type EatSessionLazyQueryHookResult = ReturnType<typeof useEatSessionLazyQuery>;
export type EatSessionSuspenseQueryHookResult = ReturnType<typeof useEatSessionSuspenseQuery>;
export type EatSessionQueryResult = ApolloReactCommon.QueryResult<EatSessionQuery, EatSessionQueryVariables>;